import { Link } from 'react-router-dom';

const navLinks = [
  { label: 'Home', href: '/' },
  { label: 'About', href: '/about' },
  { label: 'Payment', href: '/payment' },
  { label: 'Slots', href: 'https://pnggo.bet/RFLANDINGPAGEPNG' },
  { label: 'Promotion', href: 'https://pnggo.bet/RFLANDINGPAGEPNG' },
  { label: 'Guidelines', href: '/guidelines' },
  { label: 'Sign Up', href: 'https://pnggo.bet/RFLANDINGPAGEPNG' },
];

function isExternalHref(href: string) {
  return /^https?:\/\//i.test(href);
}

export default function Footer() {
  return (
    <footer className="bg-gray-200 border-t-2 border-[#B80E28] py-10">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo */}
          <Link to="/" className="flex-shrink-0">
            <img
              src="https://storage.readdy-site.link/project_files/c667a3fe-afd8-41e2-b509-06b17ff5eb78/1897808b-7c64-4faf-bdbc-437d72777f15_Image_20260417164818_372_17.png?v=7b4ee61be8e2cd668f2946d39c7e633c"
              alt="PNGGO Logo"
              className="h-16 w-auto object-contain"
            />
          </Link>

          {/* Nav Links */}
          <nav className="flex flex-wrap justify-center gap-x-6 gap-y-2">
            {navLinks.map((link) =>
              isExternalHref(link.href) ? (
                <a
                  key={link.label}
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-black/60 hover:text-[#B80E28] text-sm transition-colors cursor-pointer whitespace-nowrap"
                >
                  {link.label}
                </a>
              ) : (
                <Link
                  key={link.label}
                  to={link.href}
                  className="text-black/60 hover:text-[#B80E28] text-sm transition-colors cursor-pointer whitespace-nowrap"
                >
                  {link.label}
                </Link>
              )
            )}
          </nav>
        </div>

        <div className="mt-8 pt-6 border-t border-white/20 text-center">
          <p className="text-black/50 text-xs">
            PNGGO All rights reserved &copy; {new Date().getFullYear()}
          </p>
          <p className="text-black/40 text-xs mt-2">
            Please gamble responsibly. 18+ only. Gambling can be addictive.
          </p>
        </div>
      </div>
    </footer>
  );
}
